import { render, staticRenderFns } from "./ConsultaForm.vue?vue&type=template&id=b3d3f8be"
import script from "./ConsultaForm.vue?vue&type=script&lang=js"
export * from "./ConsultaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports